module.exports = require('./helpers/bundle-url').getBundleURL('c9iqF') + "redcard.64f029a2.png";